import { HTTP } from '@/common/utils/http';

export const LoginService = {

    login(form) {
        return HTTP.post('/no-auth/login', form);
    },

    refreshToken(expirationToken) {
        return HTTP.post('/no-auth/refresh-token', expirationToken);
    },

    getSchoolsByCurrentUser() {
        return HTTP.get(`/users/schools`);
    },

    getParentPortalURL(schoolId) {
        return HTTP.get(`/schools/${schoolId}/parent-portal-url`);
    },

    switchSchool(schoolId) {
        return HTTP.post(`/users/current/school/${schoolId}`);
    },

    adminLogin({token, schoolId}) {
        return HTTP.post(`/no-auth/admin-login/${schoolId}`, token);
    },

    logout() {
        return HTTP.delete('/logout');
    }
};


// WEBPACK FOOTER //
// ./src/common/services/login.service.js